/**
 * IMBEE-9667 — the embed URL parameters the widget reads once, at page load.
 *
 * A flag is on only for the exact string `"1"`. `hideHeaderLogo=0` and `hideHeaderLogo=false`
 * are both non-empty strings, so any truthiness check would turn an integrator's explicit
 * "off" into on — which is why the comparison is strict rather than lenient.
 */

/** True only for the exact string `"1"`. Everything else, absent included, is off. */
const isFlagEnabled = (value: string | null | undefined): boolean => value === '1';

/**
 * Read one flag from a query string.
 *
 * Takes the search string rather than reading `window`, so it can be exercised without a DOM
 * and without the module-load side effects App.tsx carries (a `localStorage` write, and a
 * `throw` on a malformed visitor token).
 */
export const readFlag = (search: string, name: string): boolean =>
    isFlagEnabled(new URLSearchParams(search).get(name));
